import { gql } from '@apollo/client';

const GET_WAREHOUSE_RELEASE_COMPONENT_VARIANTS = gql`
  query GethouseReleaseNode($id: ID!) {
    node(id: $id) {
      ... on WarehouseReleaseNode {
        id
        releaseId
        allComponentVariantsReady
        warehouseReleaseModel {
          id
          ready
        }
        componentVariantsByCategories {
          id
          componentCategory {
            id
            consumptionType {
              id
              name
              labelPL
              labelEN
            }
            type
            typeLabelPL
            typeLabelEN
          }
          componentVariants {
            id
            name
            supplierName
            calculatedConsumption
            consumptionOverride
            componentAttributesPL
            componentAttributesEN
            variantAttributesPL
            variantAttributesEN
            ready
            canBeSetToReady
            consumptionEditAvailable
            componentCategory {
              id
              type
              typeLabelPL
              typeLabelEN
              precision
              consumptionType {
                id
                name
                integerValues
                labelPL
                labelEN
              }
            }
          }
        }
      }
    }
  }
`;

export default GET_WAREHOUSE_RELEASE_COMPONENT_VARIANTS;
